export const isValidPhone = (phoneNumber: string) => {
  // Allows the following formats:
  // (123) 456-7890   (123)456-7890   123-456-7890   1234567890
  var re = /^\+?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4,6}$/im;
  return re.test(phoneNumber);
};
